import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Services } from '../../shared/services';

@Component({
    selector: 'app-sessao-expirada',
    templateUrl: './sessao-expirada.component.html'
})
export class SessaoExpiradaComponent implements OnInit
{
    constructor(protected svc: Services, private router: Router)
    {
    }

    ngOnInit(): void
    {
      this.svc.acessoExternoService.realizarLogoutGovBr(null);
    }

}





